import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { CreateFundraiserForm } from "../../components";
import { fundRaiserPageAction } from "../../store/actions";
import FundraiserForm from "./fundraiserForm";

export function EditFundraiser() {
    let dispatch = useDispatch();
    let pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details)
    let fundraiserId = window.location.pathname.split('/')[2];
    useEffect(() => {
        dispatch(fundRaiserPageAction.getFundRaiserPage(fundraiserId));
    }, [])

    return <FundraiserForm editView={true} pageDetails={pageDetails} />
}